import React from "react";
import Box from "@mui/material/Box";
import {IProgressPanelProps} from "./types";
import {useTheme} from "@mui/material/styles";
import {LinearProgress} from "@mui/material";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

export const ProgressPanel: React.FC<IProgressPanelProps> = (
    {
        title = "",
    }: IProgressPanelProps
) => {
    const theme = useTheme();

    return (
        <Box sx={{ maxWidth: "400px", width: "100%", mt: "50px" }}>
            <Grid container justifyContent={"center"}>
                <Grid item>
                    <Typography variant={"h5"} >{title}</Typography>
                </Grid>
                <Grid item>
                    <LinearProgress color={"primary"} sx={{width: "300px"}} />
                </Grid>
            </Grid>
        </Box>
    );
}